import './tik_tok_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.TikTokCommentContent extends Monitoring.Models.SocialContents.TikTokContent

  userId: ->
    return @data().author_id || @username()

  username: ->
    return @data().author_username || @data().author_name

  getRootParentId: ->
    return @data().parent_post_id

  rootPostId: ->
    return @data().parent_post_id

  rootAdExternalId: ->
    return @data().ad_id

  rootPostExternalId: ->
    return @data().parent_post_external_id
